let locationsData = [
 {
  shopId: 'lancers',
  id: 'lancers',
  instagram: "sushi_.yu",
  basePath: "/burbank", 
  cssGlobalPrefix: 'pablitoschicken',
  mapLogo: 'https://afag.imgix.net/lancers-family-restaurant/mini-logo.png?w=250&auto=format',
  // disabled: true, openingDate: "visit/call to order",
  label: "Burbank",
  className: 'night',
  address: ["697 N Victory Blvd, Burbank", "Burbank, CA 91502"],
  phone: "(818) 843-3433",
  phoneLink: "+18188433433",
  orderLink: "/burbank/order",
  lat: 34.0944399, lng:-118.128288,
  storefrontPhoto: "https://afag.imgix.net/lancers-family-restaurant/coffee.jpeg?w=600&auto=format",
  hours: [
    { day: 'Sun-Thu', hours: '8am-8pm' },
    { day: 'Fri-Sat', hours: '8am-10pm' },
  ]},
];


const siteData = {
  siteLogo: "https://d2abh92eaqfsaa.cloudfront.net/image/upload/c_fill,h_400/siaoqmaxc51cwlvxomo9.png",
  domain: "lancersfamilyrestaurant.com",
  name: "Lancers Family Restaurant | Order Delivery & Takeout",
  shortName: "Lancers",
  description: "Enjoy classic American comfort food at Lancers Family Restaurant in Burbank, California. Serving hearty breakfasts, homestyle lunches, and dinner favorites in a warm, family-friendly setting since 1968.",
  folderId: 'lancersnew',
  ogImage: "https://afag.imgix.net/lancers-family-restaurant/hero.jpeg?w=900&auto=format",
  iconRoot: "https://afag.imgix.net/lancers-family-restaurant/mini-logo.png?w=250&auto=format",
}

export { siteData };
export default locationsData;

